import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M19 3v4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 5h-4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "MoonStar";
const MoonStar = memo(themed(Icon));
export {
  MoonStar
};
//# sourceMappingURL=moon-star.js.map
